import { Badge } from "antd";
import React from "react";
import { useQuery } from "react-query";
import { api } from "../../../services/Api";

const CompanyTaskBadge = ({ id }) => {
  const fetchUnpostedCompanyBills = async () => {
    // Your fetch logic here
    return api.get(`/companies/count?filter[unPostedBillsCount][$gt]=0`);
  };
  const { data, isLoading, isError } = useQuery(
    "agentTaskscount",
    fetchUnpostedCompanyBills,
    {
      refetchInterval: 10 * 1000, // Refetch every 2 minutes
    }
  );

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error fetching data</div>;

  return (
    <div>
      Company{" "}
      <Badge
        overflowCount={Infinity} // This prevents the 99+ behavior
        showZero
        count={data?.data}
      ></Badge>
    </div>
  );
};

export default CompanyTaskBadge;
